import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../context/userContext";

export function useUserAuth() {
    // Trust localStorage for auth — no server call needed on app open.
    // Expired tokens are handled by the axios interceptor (refresh or logout).
    const token = localStorage.getItem("Token");
    const userId = localStorage.getItem("UserId");
    const isAuthenticated = !!(token && userId);

    return { isAuthenticated, authChecked: true };
}

export function ProtectedRoute({ children, requiredRoleRight, requiredRole, bypassAgreementGate, bypassApplicationGate }) {
    const { user } = useUser();
    const { isAuthenticated, authChecked } = useUserAuth();
    const location = useLocation();

    // Viewer-only users (read-only role) don't have access to the
    // Dashboard. Their landing page is /user/profile instead, and any
    // fallback redirect that would normally point to /dashboard sends
    // them to /user/profile to avoid bouncing between gated routes.
    const userRoles = user?.roles || [];
    const isViewerOnly = userRoles.length > 0 && userRoles.every(r => r === 'Viewer');
    const defaultRoute = isViewerOnly ? '/user/profile' : '/dashboard';

    if (!authChecked) {
        return (
            <div style={{ textAlign: "center", marginTop: "40px" }}>
                <div className="spinner"></div>
                <span>Loading...</span>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Application-status gate — pin pending applicants to /application-status until approved.
    const isPending = user?.applicationStatus === 'PendingReview' || user?.applicationStatus === 'PendingApproval';
    if (isPending && !bypassApplicationGate) {
        return <Navigate to="/application-status" replace />;
    }
    if (!isPending && location.pathname === '/application-status') {
        return <Navigate to={defaultRoute} replace />;
    }

    // First-login agreement gate. Bypass only on the agreement page itself.
    if (user?.mustAcceptAgreement && !bypassAgreementGate) {
        return <Navigate to="/accept-agreement" replace state={{ from: location.pathname }} />;
    }
    if (!user?.mustAcceptAgreement && location.pathname === '/accept-agreement') {
        return <Navigate to={defaultRoute} replace />;
    }

    // Viewer-only users hitting /dashboard get bounced to their landing page.
    if (isViewerOnly && location.pathname === '/dashboard') {
        return <Navigate to="/user/profile" replace />;
    }

    if (requiredRoleRight && Array.isArray(requiredRoleRight)) {
        const hasAccess = requiredRoleRight.some(right => user?.roleRights?.includes(right));

        if (!hasAccess) {
            // return <NotFound />;
            return <Navigate to={defaultRoute} replace />;
        }
    }

    if (requiredRole && Array.isArray(requiredRole)) {
        const hasRole = requiredRole.some(role => user?.roles?.includes(role));
        if (!hasRole) {
            return <Navigate to={defaultRoute} replace />;
        }
    }

    // if (requiredRight) {
    //     // User rights should now be available from Context (loaded from LocalStorage)
    //     const userRights = user?.roleRights || [];

    //     const hasRight = Array.isArray(requiredRight)
    //         ? requiredRight.some(r => userRights.includes(r))
    //         : userRights.includes(requiredRight);
    //     if (!hasRight) {
    //         return <NotFound />;
    //     }
    // }

    return children;
    // return isAuthenticated ? children : <Navigate to="/" replace />;



    // if (Array.isArray(requiredRoles) && requiredRoles.length > 0) {
    //     hasAccess = requiredRoles.some(role => userRoles.includes(role));
    //     if (isAuthenticated && !hasAccess) {
    //         return <Navigate to="/sales" replace />;
    //     }
    // }
}